<template>
  <div ref="holder" :class="holderclasses">
    <template v-if="current_brick !== undefined">
      <!--       <component
        :is="current_component"
        ref="component"
        :key="brick_id"
        :brick_id="brick_id"
        :project_id="project_id"
        :metavariables_dicts_poids="metavariables_dicts_poids"
        style="height: 100%; overflow-y: scroll; overflow-x: hidden;"
      /> -->
      <component
        :is="current_component"
        v-for="poid in available_metavariables_dicts_poids"
        ref="component"
        :key="poid"
        :brick_id="brick_id"
        :project_id="project_id"
        :current_metavariables_dict_poid="poid"
        :selected_metavariables_dicts_poids="
          available_metavariables_dicts_poids
        "
        style="height: 100%; overflow-y: scroll; overflow-x: hidden;"
      />
    </template>
  </div>
</template>

<script>
import _ from 'lodash'

import { summary_component_from_name } from './workflow_common.js'

import { WorkflowInfoPanelHandler } from './workflow_core.vue'

import { extended_dict_values } from '@/utils.js'
// import SummaryFile from './summary_file.vue'
// import SummaryDispatch from './summary_dispatch.vue'
// import SummaryModel from './summary_model.vue'
// import SummaryResult from './summary_result.vue'
// import SummaryDefault from './summary_default.vue'

// *****************************************************************************

export default {
  name: 'WorkflowInfoPanel',
  // components: {
  //   SummaryFile,
  //   SummaryDispatch,
  //   SummaryModel,
  //   SummaryResult,
  //   SummaryDefault,
  // },
  props: ['workflow_interface', 'options'],
  data() {
    let res = {
      uid: _.uniqueId('uniqueid'),
      editing: false,
    }
    return res
  },
  computed: {
    holderclasses() {
      return []
    },
    current_brick() {
      let brick
      let selection = this.workflow_interface.component.current_selection
      if (selection.length === 1) {
        const uid = selection[0]
        brick = this.workflow_interface.object_from_uid(uid)
      }
      return brick
    },
    brick_id() {
      return (this.current_brick || {}).uid
    },
    project_id() {
      return (this.current_brick || {}).project_id
    },
    current_component() {
      let brick = this.current_brick
      let component = undefined
      if (!_.isUndefined(brick)) {
        let type = brick.brick_name
        component = summary_component_from_name(type)
      }
      return component
    },
    // metavariables_dicts_poids() {
    //   let dict = this.current_brick.last_poids_build_cache || {}
    //   let res = extended_dict_values(dict)
    //   return res
    // },
    available_metavariables_dicts_poids() {
      let dict = this.current_brick.last_poids_build_cache || {}
      let res = extended_dict_values(dict)
      return res
    },
  },
  mounted() {
    this.handler = new WorkflowInfoPanelHandler(this)
    this.workflow_interface.install(this.handler)
  },
  beforeDestroy() {
    this.handler.stop()
    this.workflow_interface.uninstall(this.handler)
  },
}
</script>
